import { Button, Heading, Slider, Text } from "@radix-ui/themes";
import { AdjustmentSettings } from "./cursors";

interface AdjustmentCategoryProps {
  settings: Partial<AdjustmentSettings>;
  onSettingsChange: (settings: Partial<AdjustmentSettings>) => void;
  categoryAdjustments: Array<{
    key: keyof AdjustmentSettings;
    label: string;
    min: number;
    max: number;
    step: number;
  }>;
}

export const AdjustmentCategory = ({
  settings,
  onSettingsChange,
  categoryAdjustments,
}: AdjustmentCategoryProps) => {
  const handleSliderChange = (key: keyof AdjustmentSettings, value: number) => {
    onSettingsChange({
      ...settings,
      [key]: value,
    });
  };

  const resetCategory = () => {
    const resetValues: Partial<AdjustmentSettings> = {};
    categoryAdjustments.forEach((adjustment) => {
      if (adjustment.key === "vignetteSize") {
        resetValues[adjustment.key] = 50; // Default for vignette size
      } else {
        resetValues[adjustment.key] = adjustment.min === 0 ? 0 : 0; // Reset to 0 or min
      }
    });

    onSettingsChange({
      ...settings,
      ...resetValues,
    });
  };

  return (
    <div className="space-y-4">
      {/* Adjustments */}
      <div className="space-y-4">
        {categoryAdjustments.map((adjustment) => (
          <div key={adjustment.key} className="space-y-2">
            <div className="flex justify-between items-center">
              <Heading size="1">{adjustment.label}</Heading>
              <Text size="1">{settings[adjustment.key] || 0}</Text>
            </div>
            <Slider
              value={[settings[adjustment.key] || 0]}
              onValueChange={(value) =>
                handleSliderChange(adjustment.key, value[0])
              }
              min={adjustment.min}
              max={adjustment.max}
              step={adjustment.step}
            />
          </div>
        ))}
      </div>
      {/* Reset button */}
      <div className="flex justify-end">
        <Button variant="ghost" size="1" onClick={resetCategory}>
          Réinitialiser
        </Button>
      </div>
    </div>
  );
};
